<div class="notification-root" (click)="onContainerClick()">
    <div class="notification-accent"></div>

    <div class="notification-body">
        <div class="notification-top-row">
            <div class="notification-title-wrap">
                <div class="notification-title-row">
                    <mat-icon class="notification-icon">{{ iconName }}</mat-icon>
                    <div class="notification-title">{{ data.title }}</div>
                </div>

                <div class="notification-meta" *ngIf="data.createdAtUtc">
                    {{ data.createdAtUtc.format('DD.MM.YYYY HH:mm') }}
                </div>
            </div>

            <button
                    type="button"
                    class="close-icon"
                    [attr.aria-label]="closeLabel"
                    (click)="onCloseClick($event)">
                <mat-icon>close</mat-icon>
            </button>
        </div>

        <div class="notification-messages">
            <div
                    class="notification-message"
                    *ngFor="let msg of data.messages"
                    [innerHTML]="msg">
            </div>
        </div>

        <div class="notification-footer" *ngIf="hasAction">
            <button
                    type="button"
                    class="action-button"
                    (click)="onActionClick($event)">
                {{ actionLabel }}
            </button>
        </div>
    </div>
</div>